import { ProductCategory } from '@/graphql';
import { useUsageForBillingPeriodCategory } from '@/sections/Billing/hooks';
import { useRecoilState } from 'recoil';

import {
  selectedBillingPeriodIndexState,
  selectedOrgSharedEndpointIdState,
  selectedTrainingEntityState,
  selectedUsageItemState,
  selectedUsageTypeState,
} from './atoms';

function useSelectedBillingPeriodIndex() {
  return useRecoilState(selectedBillingPeriodIndexState);
}

function useUsageForBillingPeriodModelServing() {
  const [selectedBillingPeriodIndex] = useSelectedBillingPeriodIndex();

  return useUsageForBillingPeriodCategory(ProductCategory.ModelServing, selectedBillingPeriodIndex);
}

function useSelectedUsageItem() {
  const [selectedFilterBy, setSelectedFilterBy] = useRecoilState(selectedUsageItemState);

  return [selectedFilterBy, setSelectedFilterBy] as const;
}

function useSelectedOrgSharedEndpointId() {
  return useRecoilState(selectedOrgSharedEndpointIdState);
}

function useSelectedTrainingEntity() {
  return useRecoilState(selectedTrainingEntityState);
}

function useSelectedUsageType() {
  return useRecoilState(selectedUsageTypeState);
}

export {
  useSelectedBillingPeriodIndex,
  useSelectedUsageItem,
  useUsageForBillingPeriodModelServing,
  useSelectedUsageType,
  useSelectedOrgSharedEndpointId,
  useSelectedTrainingEntity,
};
